import { saveAs } from 'file-saver'
import moment from 'moment'
import XLSX from 'xlsx'

const PARENT_STUDENTS_HEADERS = [
  'Nombre',
  'Apellidos',
  'Genero',
  'Nivel',
  'Grado',
  'Grupo',
  'Matricula',
  'Nombre_Tutor1',
  'Apellido_Tutor1',
  'Correo_Tutor1',
]

export const funciones = {
  data: () => ({
    excel2json: null,
    excel2jsonFail: null,
    badlist: false,
    errorCode: 0,
    docMats: {},
    groupsToCreate: {},
  }),
  methods: {
    convertImageToUrl(event) {
      return new Promise((resolve) => {
        var input = event.target
        if (input.files && input.files[0]) {
          var reader = new FileReader()
          reader.onload = function (e) {
            resolve(e.target.result)
          }
          reader.readAsDataURL(input.files[0])
        }
      })
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data

      data = args.data || null
      if (data == null || !data.length) {
        return null
      }

      columnDelimiter = args.columnDelimiter || ','
      lineDelimiter = args.lineDelimiter || '\n'

      keys = Object.keys(data[0])

      result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach(function (item) {
        ctr = 0
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter

          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },

    downloadCSV: function (args) {
      var data, filename, link
      var csv = this.convertArrayOfObjectsToCSV({
        data: args.stockData,
      })
      if (csv == null) return

      filename = args.filename || 'export.csv'
      var universalBOM = '\uFEFF'

      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + universalBOM + csv
      }
      data = encodeURI(csv)

      link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', filename)
      link.click()
    },

    exportToExcel(array) {
      // On Click Excel download button

      // export json to Worksheet of Excel
      // only array possible
      var studentWS = XLSX.utils.json_to_sheet(array)

      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, studentWS, 'Hoja1') // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, 'alumnos.xlsx') // name of the file is 'book.xlsx'
    },

    exportToExcelEntregas(array) {
      // On Click Excel download button

      // export json to Worksheet of Excel
      // only array possible
      var studentWS = XLSX.utils.json_to_sheet(array)

      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, studentWS, 'Hoja1') // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, 'ReporteEntregas.xlsx') // name of the file is 'book.xlsx'
    },
    exportToXLSX(array, name) {
      var studentWS = XLSX.utils.json_to_sheet(array)
      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, studentWS, 'Hoja1') // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, name + '.xlsx') // name of the file is 'book.xlsx'
    },

    download: function (from, array) {
      var content = []
      switch (from) {
        case 'colaboradores':
          for (let i in array) {
            content.push({
              Nombre: array[i].firstName,
              Apellidos: array[i].lastName,
              Email: array[i].mail,
              Rol: array[i].webRole.name,
            })
          }
          this.downloadCSV({
            filename: 'colaboradores.csv',
            stockData: content,
          })
          break
        case 'tutores':
          for (let i in array) {
            content.push({
              Nombre: array[i].firstName,
              Apellidos: array[i].lastName,
              Email: array[i].mail,
            })
          }
          this.downloadCSV({
            filename: 'tutores.csv',
            stockData: content,
          })
          break
        case 'puertas':
          for (let i in array) {
            content.push({
              Nombre: array[i].doorName,
              Calle: array[i].street,
              Tipo: array[i].doorType,
            })
          }
          this.exportToXLSX(content, 'puertas')

          // this.downloadCSV({
          //   filename: "puertas.csv",
          //   stockData: content
          // });
          break
        case 'niveles':
          for (let i in array) {
            content.push({
              Nombre: array[i].typeLevel,
              Abreviación: array[i].abbr,
              'Hora de Salida': array[i].departureTime,
            })
          }
          this.exportToXLSX(content, 'niveles')
          // this.downloadCSV({
          //   filename: "niveles.csv",
          //   stockData: content
          // });
          break
        case 'grados':
          for (let i in array) {
            for (var j in array[i].groups) {
              content.push({
                Grado: array[i].name,
                Grupo: array[i].groups[j].name,
              })
            }
          }
          this.downloadCSV({
            filename: 'grados-grupos.csv',
            stockData: content,
          })
          break
        case 'alumnos':
          for (var i in array) {
            content.push({
              Nombre: array[i].firstName,
              Apellidos: array[i].lastName,
              Género: array[i].gender == 'MALE' ? 'Masculino' : 'Femenino',
              Nivel: array[i].level.typeLevel,
              Grado: array[i].gg.grade,
              Grupo: array[i].gg.group,
              Matrícula: array[i].personId != null ? array[i].personId : '',
            })
          }
          /////////////////////////////////////////////////
          /*this.exportToExcel({
            filename: "alumnos.xlsx",
            stockData: content
          });*/

          this.exportToExcel(content)

          break
        case 'tutores-alumnos':
          for (let i in array) {
            if (array[i].students.length > 0) {
              for (var s in array[i].students) {
                content.push({
                  'Nombre-tutor': array[i].firstName,
                  'Apellidos-tutor': array[i].lastName,
                  Email: array[i].mail,
                  'Nombre-estudiante': array[i].students[s].firstName,
                  'Apellidos-estudiante': array[i].students[s].lastName,
                  Género:
                    array[i].students[s].gender == 'MALE'
                      ? 'Masculino'
                      : 'Femenino',
                  Nivel: array[i].students[s].level.typeLevel,
                  Grado: array[i].students[s].gg.grade,
                  Grupo: array[i].students[s].gg.group,
                  Matrícula:
                    array[i].students[s].personId != null
                      ? array[i].students[s].personId
                      : '',
                })
              }
            } else {
              content.push({
                'Nombre-tutor': array[i].firstName,
                'Apellidos-tutor': array[i].lastName,
                Email: array[i].mail,
                'Nombre-estudiante': '-',
                'Apellidos-estudiante': '-',
                Género: '-',
                Grado: '-',
                Grupo: '-',
                Matrícula: '-',
              })
            }
          }
          this.downloadCSV({
            filename: 'papas-alumnos.csv',
            stockData: content,
          })
          break
        case 'alumnos-tutores':
          for (let i in array) {
            if (array[i].parents.length > 0) {
              for (let s in array[i].parents) {
                content.push({
                  'Nombre-estudiante': array[i].firstName,
                  'Apellidos-estudiante': array[i].lastName,
                  Género: array[i].gender == 'MALE' ? 'Masculino' : 'Femenino',
                  Nivel: array[i].level.typeLevel,
                  Grado: array[i].gg.grade,
                  Grupo: array[i].gg.group,
                  Matrícula:
                    array[i].personId != null ? array[i].personId : '-',
                  'Nombre-tutor': array[i].parents[s].firstName,
                  'Apellidos-tutor': array[i].parents[s].lastName,
                  Email: array[i].parents[s].mail,
                })
              }
            } else {
              content.push({
                'Nombre-estudiante': array[i].firstName,
                'Apellidos-estudiante': array[i].lastName,
                Género: array[i].gender == 'MALE' ? 'Masculino' : 'Femenino',
                Nivel: array[i].level.typeLevel,
                Grado: array[i].gg.grade,
                Grupo: array[i].gg.group,
                Matrícula: array[i].personId != null ? array[i].personId : '-',
                'Nombre-tutor': '-',
                'Apellidos-tutor': '-',
                Email: '-',
              })
            }
          }
          this.downloadCSV({
            filename: 'alumnos-papas.csv',
            stockData: content,
          })
          break
        case 'poll':
          moment.locale('es')
          for (let indexResult in array.results) {
            var result = array.results[indexResult]
            if (result.status === 'DONE') {
              var responses = []
              for (let indexQuestion in array.questions) {
                var question = array.questions[indexQuestion]
                for (let indexResultAnswer in result.answers) {
                  var resultAnswer = result.answers[indexResultAnswer]
                  for (let indexAnswer in question.answers) {
                    if (
                      question.answers[indexAnswer].id ===
                      resultAnswer.idPollQuestionAnswer
                    ) {
                      if (question.type == 'TEXT') {
                        responses.push(resultAnswer.textAnswer)
                      } else {
                        responses.push(question.answers[indexAnswer].answer)
                      }
                    }
                  }
                }

                var respuesta = ''
                for (let indexResponse in responses) {
                  var r = responses[indexResponse]
                  if (parseInt(indexResponse) !== responses.length - 1) {
                    respuesta += "'" + r + "'; "
                  } else {
                    respuesta += "'" + r + "'"
                  }
                }
                var answeredBy = ''
                if (result.parent && result.parent.name) {
                  answeredBy = result.parent.name
                }

                content.push({
                  Encuesta: '"' + array.title + '"',
                  Fecha: moment(new Date(result.answeredAt)).format(
                    'DD/MM/YYYY HH:mm:ss'
                  ),
                  Alumno:
                    result.student.firstName + ' ' + result.student.lastName,
                  Grado: result.student.gradeGroup.grade,
                  Grupo: result.student.gradeGroup.group,
                  Pregunta: '"' + question.question + '"',
                  Respuesta: '"' + respuesta + '"',
                  'Contestada por': '"' + answeredBy + '"',
                })
                respuesta = ''
                responses = []
              }
            }
          }

          var docName = array.title
          if (!array.isAll) {
            docName =
              array.title +
              '_' +
              result.student.firstName +
              result.student.lastName
          }
          this.downloadCSV({
            filename: docName + '.csv',
            stockData: content,
          })
          break
        case 'pollCol':
          for (let indexQuestion in array.questions) {
            var question = array.questions[indexQuestion]
            for (let indexResult in array.results) {
              var result = array.results[indexResult]
              if (result.status === 'DONE') {
                var responses = []
                for (let indexResultAnswer in result.answers) {
                  var resultAnswer = result.answers[indexResultAnswer]
                  for (let indexAnswer in question.answers) {
                    if (
                      question.answers[indexAnswer].id ===
                      resultAnswer.idPollQuestionAnswer
                    ) {
                      if (question.type == 'TEXT') {
                        responses.push(resultAnswer.textAnswer)
                      } else {
                        responses.push(question.answers[indexAnswer].answer)
                      }
                    }
                  }
                }
                var respuesta = ''
                for (let indexResponse in responses) {
                  var r = responses[indexResponse]
                  if (parseInt(indexResponse) !== responses.length - 1) {
                    respuesta += "'" + r + "'; "
                  } else {
                    respuesta += "'" + r + "'"
                  }
                }
                content.push({
                  Encuesta: '"' + array.title + '"',
                  Fecha: new Date(result.createdAt).toISOString().substr(0, 10),
                  Colaborador:
                    result.collaborator.firstName +
                    ' ' +
                    result.collaborator.lastName,
                  Pregunta: '"' + question.question + '"',
                  Respuesta: '"' + respuesta + '"',
                })
              }
            }
          }
          var docName = array.title
          if (!array.isAll) {
            docName =
              array.title +
              '_' +
              result.student.firstName +
              result.student.lastName
          }
          this.downloadCSV({
            filename: docName + '.csv',
            stockData: content,
          })
          break

        case 'pollCol1':
          for (let indexQuestion in array.questions) {
            var question = array.questions[indexQuestion]
            for (let indexResult in array.results) {
              var result = array.results[indexResult]
              if (result.status === 'DONE') {
                if (
                  array.collaborator.firstName ==
                    result.collaborator.firstName &&
                  result.collaborator.lastName == array.collaborator.lastName
                ) {
                  var responses = []
                  for (let indexResultAnswer in result.answers) {
                    var resultAnswer = result.answers[indexResultAnswer]
                    for (let indexAnswer in question.answers) {
                      if (
                        question.answers[indexAnswer].id ===
                        resultAnswer.idPollQuestionAnswer
                      ) {
                        if (question.type == 'TEXT') {
                          responses.push(resultAnswer.textAnswer)
                        } else {
                          responses.push(question.answers[indexAnswer].answer)
                        }
                      }
                    }
                  }
                  var respuesta = ''
                  for (let indexResponse in responses) {
                    var r = responses[indexResponse]
                    if (parseInt(indexResponse) !== responses.length - 1) {
                      respuesta += "'" + r + "'; "
                    } else {
                      respuesta += "'" + r + "'"
                    }
                  }
                  content.push({
                    Encuesta: '"' + array.title + '"',
                    Fecha: new Date(result.createdAt)
                      .toISOString()
                      .substr(0, 10),
                    Colaborador:
                      result.collaborator.firstName +
                      ' ' +
                      result.collaborator.lastName,
                    Pregunta: '"' + question.question + '"',
                    Respuesta: '"' + respuesta + '"',
                  })
                }
              }
            }
          }
          var docName = array.title
          if (!array.isAll) {
            docName =
              array.title +
              '_' +
              result.student.firstName +
              result.student.lastName
          }
          this.downloadCSV({
            filename: docName + '.csv',
            stockData: content,
          })
          break
        case 'reporte-entregas':
          for (var i in array) {
            content.push({
              Grado: array[i].grade,
              Nivel: array[i].level,
              Nombre: array[i].firstName,
              Apellidos: array[i].lastName,
              Matrícula: array[i].personId != null ? array[i].personId : '',

              'Fecha/Hora Solicitado': array[i].createdAt,
              'Fecha/Hora Camino': array[i].calledTime,
              'Fecha/Hora Entregado': array[i].deliveryTime,
              'Fecha/Hora Cancelado': array[i].cancelledTime,

              'Nombre Solicitante': array[i].parentName,
              'Apellido Solicitante': array[i].parentLastName,
              'Nombre quien Cancelo': array[i].whoCancelled,

              Usuario: array[i].typeReq,
              Puerta: array[i].door,
              Auto: array[i].carModel,
              Color: array[i].carColor,
              Placas: array[i].plates,
            })
          }
          this.exportToExcelEntregas(content)
          break
      }
    },
    processFile(files, value, from, array) {
      return new Promise((resolve, reject) => {
        this.excel2json = []
        this.excel2jsonFail = []
        if (files.length > 0) {
          var allowedExtensions = /(.xlsx|.csv)$/i
          var ext = allowedExtensions.exec(value) ? 'xlsx' : '-'
          switch (ext) {
            case 'xlsx':
              //console.log("si es xlsx");
              return this.convertExcelToJSON(
                files[0],
                from,
                resolve,
                reject,
                array
              )
            default:
              //console.log("no es xlsx");
              this.errorCode = 403
              reject(403)
          }
        }
      })
    },
    processFilesSP(files, value, from, array) {
      return new Promise((resolve, reject) => {
        this.excel2json = []
        this.excel2jsonFail = []
        if (files.length > 0) {
          var allowedExtensions = /(.xlsx|.csv)$/i
          var ext = allowedExtensions.exec(value) ? 'xlsx' : '-'
          switch (ext) {
            case 'xlsx':
              //console.log("si es xlsx");
              return this.convertExcelToJSON(
                files[0],
                from,
                resolve,
                reject,
                array
              )
            default:
              //console.log("no es xlsx");
              this.errorCode = 403
              reject(403)
          }
        }
      })
    },
    convertExcelToJSON(file, from, resolve, reject, array) {
      if (typeof require !== 'undefined') var XLSX = require('xlsx')
      var rdr = new FileReader()
      var v = this

      //Runs after rdr.readAsArrayBuffer
      rdr.onload = function () {
        var data = new Uint8Array(rdr.result)
        var arr = new Array()
        for (var i = 0; i != data.length; ++i)
          arr[i] = String.fromCharCode(data[i])
        var bstr = arr.join('')

        // Call XLSX
        var workbook = XLSX.read(bstr, {
          type: 'binary',
        })
        var c = 0
        var ch = 0
        // DO SOMETHING WITH workbook HERE
        var first_sheet_name = workbook.SheetNames[0]
        // Get worksheet
        var worksheet = workbook.Sheets[first_sheet_name]

        //Get "Headers", first row from first sheet
        var headerRegex = new RegExp("^([A-Za-z]+)1='(.*)$")
        var cells = XLSX.utils.sheet_to_formulae(worksheet)
        var headers = cells
          .filter((item) => headerRegex.test(item))
          .map((item) => item.split("='")[1])

        v.excel2json = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
        })

        switch (from) {
          case 'Colaboradores':
            for (let h of workbook.Strings) {
              if (c <= 11) {
                c++
                switch (h.t) {
                  case 'Nombre':
                    ch++
                    break
                  case 'Apellidos':
                    ch++
                    break
                  case 'Correo':
                    ch++
                    break
                  case 'Rol':
                    ch++
                    break
                }
              } else {
                break
              }
            }
            if (ch != 4) {
              v.errorCode = 403
              reject(403)
            } else {
              return v.validateExcelColab(resolve, reject, array)
            }
            break
          case 'Alumnos':
            for (let h of workbook.Strings) {
              if (c <= 11) {
                c++
                switch (h.t) {
                  case 'Nombre':
                    ch++
                    break
                  case 'Apellidos':
                    ch++
                    break
                  case 'Nivel':
                    ch++
                    break
                  case 'Grado':
                    ch++
                    break
                  case 'Grupo':
                    ch++
                    break
                  case 'Genero':
                    ch++
                    break
                  case 'Matricula':
                    ch++
                    break
                }
              } else {
                break
              }
            }
            if (ch != 7) {
              v.errorCode = 403
              reject(403)
            } else {
              return v.validateExcel(resolve, reject, array)
            }
            break
          case 'tutores-alumnos':
            //Verify headers
            let validHeaders = PARENT_STUDENTS_HEADERS.every((h) =>
              headers.includes(h)
            )

            if (validHeaders) {
              return v.validateExcelStdsPars(resolve, reject, array)
            } else {
              v.errorCode = 403
              reject(403)
            }

            break

          case 'alumnos-extras':
            for (let h of workbook.Strings) {
              if (c <= 11) {
                c++
                switch (h.t) {
                  case 'Matricula':
                    ch++
                    break
                  case 'Nivel':
                    ch++
                    break
                  case 'Actividad':
                    ch++
                    break
                  case 'Grupo':
                    ch++
                    break
                }
              } else {
                break
              }
            }
            if (ch != 4) {
              v.errorCode = 403
              reject(403)
            } else {
              return v.validateExcelStdsExtras(resolve, reject, array)
            }
            break
        }
      }

      rdr.readAsArrayBuffer(file)
    },
    validateExcelColab(resolve, reject, roles) {
      this.excel2jsonFail = []
      var keys = []
      var val
      var sub_key
      var c = 0
      for (var I = 0; I < this.excel2json.length; I++) {
        keys = []
        val = this.excel2json[I]
        for (var i in val) {
          sub_key = i
          keys.push(sub_key)
        }
        if (!keys.includes('Nombre')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Nombre no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Apellidos')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Apellidos no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Correo')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Correo no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Rol')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Rol no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        }
      }
      var emailReg = /[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/
      var flag = false
      for (let i = 0; i < this.excel2json.length; i++) {
        flag = false
        if (
          this.excel2json[i].Nombre === '' ||
          this.excel2json[i].Apellidos === '' ||
          this.excel2json[i].Correo === '' ||
          this.excel2json[i].Rol === '' ||
          !emailReg.test(this.excel2json[i].Correo)
        ) {
          this.excel2jsonFail.push(this.excel2json[i])
          this.excel2json.splice(this.excel2json.indexOf(this.excel2json[i]), 1)
          i--
          flag = true
        }
        if (flag) {
          this.excel2jsonFail.push(this.excel2json[i])
          this.excel2json.splice(this.excel2json.indexOf(this.excel2json[i]), 1)
          i--
        }
      }
      if (this.excel2json.length > 0) {
        if (c > 0) {
          this.badlist = true
          this.errorCode = 201
          this.rolExist(reject, resolve, roles)
        } else {
          this.rolExist(reject, resolve, roles)
          this.errorCode = 200
        }
      } else {
        this.badlist = true
        this.errorCode = 201
        resolve(201)
      }
    },

    validateExcelStdsExtras(resolve, reject, array) {
      this.excel2jsonFail = []
      var keys = []
      var val
      var sub_key
      var c = 0
      for (var I = 0; I < this.excel2jsonFail.length; I++) {
        keys = []
        val = this.excel2jsonFail[I]
        for (var i in val) {
          sub_key = i
          keys.push(sub_key)
        }
        if (!keys.includes('Matricula')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Matrícula no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Nivel')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Nivel no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Actividad')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Actividad no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Grupo')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Grupo no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        }
      }
      for (let i = 0; i < this.excel2json.length; i++) {
        if (
          !this.excel2json[i].Matricula ||
          !this.excel2json[i].Nivel ||
          !this.excel2json[i].Actividad ||
          !this.excel2json[i].Grupo
        ) {
          let tempObj = this.excel2json.splice(i, 1)[0]
          tempObj.Error = 'Campos Vacíos'
          this.excel2jsonFail.push(tempObj)
          i--
        }
      }
      if (this.excel2json.length > 0) {
        if (c > 0) {
          this.badlist = true
          this.errorCode = 201
          this.levelExistExtra(reject, resolve, array)
        } else {
          this.errorCode = 200
          this.levelExistExtra(reject, resolve, array)
        }
      } else {
        this.badlist = true
        this.errorCode = 201
        resolve(201)
      }
    },

    validateExcelStdsPars(resolve, reject, array) {
      this.excel2jsonFail = []
      var keys = []
      var val
      var sub_key
      var c = 0
      this.docMats = {}

      for (var I = 0; I < this.excel2jsonFail.length; I++) {
        keys = []
        val = this.excel2jsonFail[I]
        for (var i in val) {
          sub_key = i
          keys.push(sub_key)
        }
        if (!keys.includes('Nombre')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Nombre no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Apellidos')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Apellidos no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Genero')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Genero no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Nivel')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Nivel no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Grado')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Grado no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Grupo')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Grupo no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Genero')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Genero no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Matricula')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Matricula no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        }
      }
      for (let i = 0; i < this.excel2json.length; i++) {
        if (this.excel2json[i].Nombre_Tutor1 != null) {
          this.excel2json[i].Nombre_Tutor1 =
            this.excel2json[i].Nombre_Tutor1.trim()
        }
        if (this.excel2json[i].Apellido_Tutor1 != null) {
          this.excel2json[i].Apellido_Tutor1 =
            this.excel2json[i].Apellido_Tutor1.trim()
        }
        if (this.excel2json[i].Correo_Tutor1 != null) {
          this.excel2json[i].Correo_Tutor1 =
            this.excel2json[i].Correo_Tutor1.trim()
        }
        if (this.excel2json[i].Nombre_Tutor2 != null) {
          this.excel2json[i].Nombre_Tutor2 =
            this.excel2json[i].Nombre_Tutor2.trim()
        }
        if (this.excel2json[i].Apellido_Tutor2 != null) {
          this.excel2json[i].Apellido_Tutor2 =
            this.excel2json[i].Apellido_Tutor2.trim()
        }
        if (this.excel2json[i].Correo_Tutor2 != null) {
          this.excel2json[i].Correo_Tutor2 =
            this.excel2json[i].Correo_Tutor2.trim()
        }
        delete this.excel2json[i].Error
        if (
          this.excel2json[i].Nombre === undefined ||
          this.excel2json[i].Apellidos === undefined ||
          this.excel2json[i].Genero === undefined ||
          this.excel2json[i].Nivel === undefined ||
          this.excel2json[i].Grado === undefined ||
          this.excel2json[i].Grupo === undefined ||
          this.excel2json[i].Matricula === undefined
          // !this.excel2json[i].Nombre ||
          // !this.excel2json[i].Apellidos ||
          // !this.excel2json[i].Genero ||
          // !this.excel2json[i].Nivel ||
          // !this.excel2json[i].Grado ||
          // !this.excel2json[i].Grupo ||
          // !this.excel2json[i].Matricula
        ) {
          let tempObj = this.excel2json.splice(i, 1)[0]
          tempObj.Error = 'Campos Vacíos'
          this.excel2jsonFail.push(tempObj)
          i--
        } else {
          this.docMats[this.excel2json[i].Matricula]
            ? (this.docMats[this.excel2json[i].Matricula] =
                this.docMats[this.excel2json[i].Matricula] + 1)
            : (this.docMats[this.excel2json[i].Matricula] = 1)
          var gender = this.excel2json[i].Genero.toUpperCase().trim()
          if (gender === 'MASCULINO' || gender === 'MALE') {
            this.excel2json[i].Genero = 'MALE'
          } else if (gender === 'FEMENINO' || gender === 'FEMALE') {
            this.excel2json[i].Genero = 'FEMALE'
          } else if (
            gender != 'MASCULINO' ||
            gender != 'FEMENINO' ||
            gender != 'MALE' ||
            gender != 'FEMALE'
          ) {
            let tempObj = this.excel2json.splice(i, 1)[0]
            tempObj.Error = 'Género incorrecto'
            this.excel2jsonFail.push(tempObj)
            c++
            i--
          }
        }
      }
      if (this.excel2json.length > 0) {
        if (c > 0) {
          this.badlist = true
          this.errorCode = 201
          this.levelExistParsStds(reject, resolve, array)
        } else {
          this.errorCode = 200
          this.levelExistParsStds(reject, resolve, array)
        }
      } else {
        this.badlist = true
        this.errorCode = 201
        resolve(201)
      }
    },
    validatePars(reject, resolve) {
      var parNum = 0

      for (var a in this.excel2json) {
        for (var i in this.excel2json[a]) {
          if (String(i).includes('Tutor')) {
            var result = String(i).search('Tutor')
            var number = parseInt(String(i).substring(result + 5))
            parNum > number ? null : (parNum = number)
          }
        }
      }

      if (
        this.errorItems &&
        this.excel2json[0] &&
        this.excel2json[0].parents &&
        this.excel2json[0].parents.length
      ) {
        for (var s in this.excel2json) {
          for (var p in this.excel2json[s].parents) {
            if (this.excel2json[s].parents[p] != null) {
              this.excel2json[s]['Nombre_Tutor' + String(parseInt(p) + 1)] =
                this.excel2json[s].parents[p].firstName

              this.excel2json[s]['Apellido_Tutor' + String(parseInt(p) + 1)] =
                this.excel2json[s].parents[p].lastName

              this.excel2json[s]['Correo_Tutor' + String(parseInt(p) + 1)] =
                this.excel2json[s].parents[p].mail
            }
          }
        }
      }

      this.parNum = parNum

      jsonExcel: for (let i = 0; i < this.excel2json.length; i++) {
        var item = this.excel2json[i]
        parentsFor: for (let p = 1; p <= parNum; p++) {
          if (
            !item['Nombre_Tutor' + p] &&
            !item['Apellido_Tutor' + p] &&
            !item['Correo_Tutor' + p]
          ) {
            continue parentsFor
          } else {
            if (
              !item['Nombre_Tutor' + p] ||
              item['Nombre_Tutor' + p] == '-' ||
              item['Nombre_Tutor' + p] == ''
            ) {
              this.excel2json[i]['Nombre_Tutor' + p] = '-'
              let tempObj = this.excel2json.splice(i, 1)[0]
              tempObj.Error = 'Nombre tutor ' + p + ' no existe'
              this.excel2jsonFail.push(tempObj)
              i--
              continue jsonExcel
            }
            if (
              !item['Apellido_Tutor' + p] ||
              item['Apellido_Tutor' + p] == '-' ||
              item['Nombre_Tutor' + p] == ''
            ) {
              this.excel2json[i]['Apellido_Tutor' + p] = '-'
              let tempObj = this.excel2json.splice(i, 1)[0]
              tempObj.Error = 'Apellido tutor ' + p + ' no existe'
              this.excel2jsonFail.push(tempObj)
              i--
              continue jsonExcel
            }
            if (
              !item['Correo_Tutor' + p] ||
              item['Correo_Tutor' + p] == '-' ||
              item['Nombre_Tutor' + p] == ''
            ) {
              if (this.excel2json[i]) {
                this.excel2json[i]['Correo_Tutor' + p] = '-'
                let tempObj = this.excel2json.splice(i, 1)[0]
                tempObj.Error = 'Correo tutor ' + p + ' no existe'
                this.excel2jsonFail.push(tempObj)
                i--
                continue jsonExcel
              }
            }
          }
        }
      }
      if (this.excel2json.length > 0) {
        if (this.excel2jsonFail.length > 0) {
          this.errorCode = 201
          resolve(201)
        } else {
          this.errorCode = 200
          resolve(200)
        }
      } else {
        this.errorCode = 201
        resolve(201)
      }
    },

    levelExistExtra(reject, resolve, obj) {
      var levels = obj.levels
      var abbrs = obj.abbrs
      ver: for (var i = 0; i < this.excel2json.length; i++) {
        let excelRow = this.excel2json[i]
        let xNivel =
          excelRow.Nivel === undefined
            ? ''
            : ('' + excelRow.Nivel).toLowerCase()
        let xActividad =
          excelRow.Actividad === undefined ? '' : '' + excelRow.Actividad
        let xGrupo =
          excelRow.Grupo === undefined
            ? ''
            : ('' + excelRow.Grupo).toLowerCase()
        let pair = xActividad + xGrupo

        if (levels[xNivel]) {
          excelRow.level = {
            id: levels[xNivel][0],
          }
          if (levels[xNivel][1][pair]) {
            excelRow.gg = {
              id: levels[xNivel][1][pair],
            }
          } else {
            excelRow.gg = {
              id: -5,
              grade: xActividad,
              group: excelRow.Grupo,
            }
          }
        } else if (abbrs[xNivel]) {
          excelRow.level = {
            id: abbrs[xNivel][0],
          }
          if (abbrs[xNivel][1][pair]) {
            excelRow.gg = {
              id: abbrs[xNivel][1][pair],
            }
          } else {
            excelRow.gg = {
              id: -5,
              grade: xActividad,
              group: excelRow.Grupo,
            }
          }
        } else {
          excelRow.Error = 'Nivel no existente'
          excelRow.level = {
            typeLevel: excelRow.Nivel,
          }
          excelRow.gg = {
            grade: xActividad,
            group: excelRow.Grupo,
          }
          let tempObj = this.excel2json.splice(i, 1)[0]
          this.excel2jsonFail.push(tempObj)
          i--
          continue ver
        }
      }

      if (this.excel2json.length > 0) {
        if (this.excel2jsonFail.length > 0) {
          this.errorCode = 201
          resolve(201)
        } else {
          this.errorCode = 200
          resolve(200)
        }
      } else {
        this.errorCode = 201
        resolve(201)
      }
    },
    levelExistParsStds(reject, resolve, obj) {
      var levels = obj.levels
      var abbrs = obj.abbrs
      ver: for (var i = 0; i < this.excel2json.length; i++) {
        let nivel = String(this.excel2json[i].Nivel).toLowerCase()
        let grado = this.excel2json[i].Grado
        let grupo = this.excel2json[i].Grupo

        if (levels[nivel]) {
          this.excel2json[i].level = {
            id: levels[nivel][0],
          }
          if (levels[nivel][1][grado + '' + (grupo + '').toLowerCase()]) {
            this.excel2json[i].gg = {
              grade: grado,
              group: grupo,
            }
          } else {
            this.excel2json[i].gg = {
              grade: grado,
              group: grupo,
            }
          }
        } else if (abbrs[nivel]) {
          this.excel2json[i].level = {
            id: abbrs[nivel][0],
          }
          if (abbrs[nivel][1][grado + '' + (grupo + '').toLowerCase()]) {
            this.excel2json[i].gg = {
              grade: grado,
              group: grupo,
            }
          } else {
            this.excel2json[i].gg = {
              grade: grado,
              group: grupo,
            }
          }
        } else {
          this.excel2json[i].Error = 'Nivel no existente'
          this.excel2json[i].level = {
            typeLevel: this.excel2json[i].Nivel,
          }
          this.excel2json[i].gg = {
            grade: grado,
            group: grupo,
          }
          let tempObj = this.excel2json.splice(i, 1)[0]
          this.excel2jsonFail.push(tempObj)
          i--
          continue ver
        }
      }
      if (this.excel2json.length > 0) {
        if (this.excel2jsonFail.length > 0) {
          this.errorCode = 201
          this.validatePars(reject, resolve, obj)
        } else {
          this.errorCode = 200
          this.validatePars(reject, resolve, obj)
        }
      } else {
        this.errorCode = 201
        resolve(201)
      }
    },

    validateExcel(resolve, reject, obj) {
      this.excel2jsonFail = []
      var keys = []
      var val
      var sub_key
      var c = 0
      this.docMats = {}
      for (var I = 0; I < this.excel2jsonFail.length; I++) {
        keys = []
        val = this.excel2jsonFail[I]
        for (var i in val) {
          sub_key = i
          keys.push(sub_key)
        }
        if (!keys.includes('Nombre')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Nombre no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Apellidos')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Apellidos no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Genero')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Genero no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Nivel')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Nivel no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Grado')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Grado no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Grupo')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Grupo no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        } else if (!keys.includes('Matricula')) {
          let tempObj = this.excel2json.splice(I, 1)[0]
          tempObj.Error = 'Matrícula no existe'
          this.excel2jsonFail.push(tempObj)
          c++
          I--
          continue
        }
      }
      for (let i = 0; i < this.excel2json.length; i++) {
        if (this.excel2json[i].Correo_Tutor1 != null) {
          this.excel2json[i].Correo_Tutor1 =
            this.excel2json[i].Correo_Tutor1.trim()
        }
        if (this.excel2json[i].Correo_Tutor2 != null) {
          this.excel2json[i].Correo_Tutor2 =
            this.excel2json[i].Correo_Tutor2.trim()
        }

        if (
          !this.excel2json[i].Nombre ||
          !this.excel2json[i].Apellidos ||
          !this.excel2json[i].Genero ||
          !this.excel2json[i].Nivel ||
          !this.excel2json[i].Grado ||
          !this.excel2json[i].Grupo ||
          !this.excel2json[i].Matricula
        ) {
          let tempObj = this.excel2json.splice(i, 1)[0]
          tempObj.Error = 'Campos Vacíos'
          this.excel2jsonFail.push(tempObj)
          i--
        } else {
          this.docMats[this.excel2json[i].Matricula]
            ? (this.docMats[this.excel2json[i].Matricula] =
                this.docMats[this.excel2json[i].Matricula] + 1)
            : (this.docMats[this.excel2json[i].Matricula] = 1)
          var gender = this.excel2json[i].Genero.toUpperCase().trim()
          if (gender === 'MASCULINO' || gender === 'MALE') {
            this.excel2json[i].Genero = 'MALE'
          } else if (gender === 'FEMENINO' || gender === 'FEMALE') {
            this.excel2json[i].Genero = 'FEMALE'
          } else if (
            gender != 'MASCULINO' ||
            gender != 'FEMENINO' ||
            gender != 'MALE' ||
            gender != 'FEMALE'
          ) {
            let tempObj = this.excel2json.splice(i, 1)[0]
            tempObj.Error = 'Género incorrecto'
            this.excel2jsonFail.push(tempObj)
            c++
            i--
          }
        }
      }
      if (this.excel2json.length > 0) {
        if (c > 0) {
          this.badlist = true
          this.errorCode = 201
          this.levelExist(reject, resolve, obj)
          resolve(201)
        } else {
          this.errorCode = 200
          this.levelExist(reject, resolve, obj)
          resolve(200)
        }
      } else {
        this.badlist = true
        this.errorCode = 201
        resolve(201)
      }
    },
    rolExist(reject, resolve, roles) {
      var matriculas = []
      for (var i = 0; i < this.excel2json.length; i++) {
        if (matriculas[this.excel2json[i].Correo] == null) {
          matriculas[this.excel2json[i].Correo] = new Array()
          matriculas[this.excel2json[i].Correo].push(this.excel2json[i])
        } else {
          this.excel2json[i].Error = 'Correo Repetido'
          let tempObj = this.excel2json.splice(i, 1)[0]
          i--
          this.excel2jsonFail.push(tempObj)
        }
        var exist = false
        for (var j = 0; j < roles.length; j++) {
          if (
            this.excel2json[i].Rol.toUpperCase() == roles[j].name.toUpperCase()
          ) {
            exist = true
            this.excel2json[i].webRole = {
              id: roles[j].id,
            }
            break
          }
        }
        if (!exist) {
          this.excel2json[i].Error = 'El rol no existe'
          let tempObj = this.excel2json.splice(i, 1)[0]
          i--
          this.excel2jsonFail.push(tempObj)
        }
      }
      if (this.excel2json.length > 0) {
        if (this.excel2jsonFail.length > 0) {
          this.errorCode = 201
          resolve(201)
        } else {
          this.errorCode = 200
          resolve(200)
        }
      } else {
        this.errorCode = 404
        reject(404)
      }
    },
    levelExist(reject, resolve, obj) {
      var levels = obj.levels
      var mats = obj.mats
      var abbrs = obj.abbrs

      ver: for (var i = 0; i < this.excel2json.length; i++) {
        if (mats[this.excel2json[i].Matricula]) {
          this.excel2json[i].Error = 'Matrícula ya existente'
          let tempObj = this.excel2json.splice(i, 1)[0]
          this.excel2jsonFail.push(tempObj)
          i--
          continue ver
        }
        if (this.docMats[this.excel2json[i].Matricula] > 1) {
          this.excel2json[i].Error = 'Matrícula repetida en el documento'
          let tempObj = this.excel2json.splice(i, 1)[0]
          this.excel2jsonFail.push(tempObj)
          i--
          continue ver
        }
        if (
          this.excel2json[i].Nivel &&
          levels[(this.excel2json[i].Nivel + '').toLowerCase()]
        ) {
          this.excel2json[i].level = {
            id: levels[(this.excel2json[i].Nivel + '').toLowerCase()][0],
          }
          if (
            levels[(this.excel2json[i].Nivel + '').toLowerCase()][1][
              this.excel2json[i].Grado +
                '' +
                (this.excel2json[i].Grupo + '').toLowerCase()
            ]
          ) {
            this.excel2json[i].gg = {
              id: levels[(this.excel2json[i].Nivel + '').toLowerCase()][1][
                this.excel2json[i].Grado +
                  '' +
                  (this.excel2json[i].Grupo + '').toLowerCase()
              ],
            }
          } else {
            /*this.excel2json[i].Error = "Grado y grupo no existente";
            let tempObj = this.excel2json.splice(i, 1)[0];

            this.excel2jsonFail.push(tempObj);
            i--;
            continue ver;*/
            this.excel2json[i].gg = {
              id: -5,
              grade: this.excel2json[i].Grado,
              group: this.excel2json[i].Grupo,
            }
          }
        } else if (
          this.excel2json[i].Nivel &&
          abbrs[(this.excel2json[i].Nivel + '').toLowerCase()]
        ) {
          this.excel2json[i].level = {
            id: abbrs[(this.excel2json[i].Nivel + '').toLowerCase()][0],
          }
          if (
            abbrs[(this.excel2json[i].Nivel + '').toLowerCase()][1][
              this.excel2json[i].Grado +
                '' +
                (this.excel2json[i].Grupo + '').toLowerCase()
            ]
          ) {
            this.excel2json[i].gg = {
              id: abbrs[(this.excel2json[i].Nivel + '').toLowerCase()][1][
                this.excel2json[i].Grado +
                  '' +
                  (this.excel2json[i].Grupo + '').toLowerCase()
              ],
            }
          } else {
            /*this.excel2json[i].Error = "Grado y grupo no existente";
            let tempObj = this.excel2json.splice(i, 1)[0];

            this.excel2jsonFail.push(tempObj);
            i--;
            continue ver;*/
            this.excel2json[i].gg = {
              id: -5,
              grade: this.excel2json[i].Grado,
              group: this.excel2json[i].Grupo,
            }
          }
        } else {
          this.excel2json[i].Error = 'Nivel no existente'
          let tempObj = this.excel2json.splice(i, 1)[0]

          this.excel2jsonFail.push(tempObj)
          i--
          continue ver
        }
      }
      if (this.excel2json.length > 0) {
        if (this.excel2jsonFail.length > 0) {
          this.errorCode = 201
          resolve(201)
        } else {
          this.errorCode = 200
          resolve(200)
        }
      } else {
        this.errorCode = 201
        reject(201)
      }
    },
    downloadbadExcelColab() {
      if (typeof require !== 'undefined') var XLSX = require('xlsx')
      var wb = XLSX.utils.book_new()
      var now = new Date()
      var day = ('0' + now.getDate()).slice(-2)
      var month = ('0' + (now.getMonth() + 1)).slice(-2)
      var today = now.getFullYear() + '-' + month + '-' + day
      wb.Props = {
        Title: 'lista de Colaboradores Erroneos',
        Subject: 'Lista',
        Author: 'Skolable',
        CreatedDate: today,
      }

      wb.SheetNames.push('Lista de Colaboradores Erroneos')
      var ws_data = this.excel2jsonFail
      var ws = XLSX.utils.json_to_sheet(ws_data)
      wb.Sheets['Lista de Colaboradores Erroneos'] = ws
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'binary',
      })

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }
      var blob = new Blob([s2ab(wbout)], {
        type: 'application/octet-stream',
      })
      saveAs(blob, 'lista_colaboradores_erroneos.xlsx')
    },

    downloadbadExcelStudents() {
      if (typeof require !== 'undefined') var XLSX = require('xlsx')
      var wb = XLSX.utils.book_new()
      var now = new Date()
      var day = ('0' + now.getDate()).slice(-2)
      var month = ('0' + (now.getMonth() + 1)).slice(-2)
      var today = now.getFullYear() + '-' + month + '-' + day
      wb.Props = {
        Title: 'lista de estudiantes erroneos',
        Subject: 'Lista',
        Author: 'Skolable',
        CreatedDate: today,
      }

      wb.SheetNames.push('Lista de estudiantes erroneos')
      var ws_data = this.excel2jsonFail
      var ws = XLSX.utils.json_to_sheet(ws_data)
      wb.Sheets['Lista de estudiantes erroneos'] = ws
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'binary',
      })

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }
      var blob = new Blob([s2ab(wbout)], {
        type: 'application/octet-stream',
      })
      saveAs(blob, 'lista_estudiantes_erroneos.xlsx')
    },

    downloadReport(content) {
      if (typeof require !== 'undefined') var XLSX = require('xlsx')
      var wb = XLSX.utils.book_new()
      var now = new Date()
      var day = ('0' + now.getDate()).slice(-2)
      var month = ('0' + (now.getMonth() + 1)).slice(-2)
      var today = now.getFullYear() + '-' + month + '-' + day
      wb.Props = {
        Title: 'Reporte de importación',
        Subject: 'Lista',
        Author: 'Skolable',
        CreatedDate: today,
      }

      wb.SheetNames.push('Reporte de importación')
      var ws_data = content
      var ws = XLSX.utils.json_to_sheet(ws_data)
      wb.Sheets['Reporte de importación'] = ws
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'binary',
      })

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }
      var blob = new Blob([s2ab(wbout)], {
        type: 'application/octet-stream',
      })
      saveAs(blob, 'reporte de importacion.xlsx')
    },
    momentDownoald: function (value) {
      if (value) {
        return moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss')
      }
      return '-'
    },
  },
}
